import PropTypes from 'prop-types';
import { AddToPopular, AddToPopularIcon } from './AddToPopularButton.style';

function AddToPopularButton({ value: isPopular, onClick }) {
  return (
    <AddToPopular type="button" onClick={onClick}>
      <AddToPopularIcon isPopular={isPopular} />
      {isPopular ? 'Popular' : 'Add to Popular'}
    </AddToPopular>
  );
}

AddToPopularButton.propTypes = {
  value: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AddToPopularButton;
